<template>
  <div class="outerDiv" :style="configStyle">
    <div class="headerclass">
        <navheader @logout="logout"/>
    </div>
        

        <div :class="mainDivClass">
            <loginuser ref="loginuser" v-if="!loggedIn" />
            <div v-if="loggedIn">
                <openclose v-if="currentNav=='openclose'" @hide="currentNav=''"/>
                <productgroup v-if="currentNav=='productgroup'"/>
                <productadmin v-if="currentNav=='product'" ref="productadmin"/>
                <transactions v-if="currentNav=='transactions'" ref="transactions"/>
                <inventory v-if="currentNav=='inventory'" />
                <library v-if="currentNav=='library'"/>
                <vendor v-if="currentNav=='vendor'"/>
            </div>
        </div>

        <!-- <spfooter/>   -->
        
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import style from '../style.js'
import format from '../format.js'
import datamethods from '../services/datamethods.js'
import spfooter from './footer.vue'
import navheader from './navheader.vue'
import loginuser from './loginuser.vue'
import openclose from './openclose/openclose.vue'
import productgroup from './productgroup/productgroup.vue'
import productadmin from './product/productadmin.vue'
import transactions from './transactions/transactions.vue'
import inventory from './inventory/inventory.vue'
import library from './library/library.vue'
import inventoryservice from '../services/inventoryservice.js'
import vendor from './vendor/vendor.vue'
export default {
    components:{
        spfooter,
        navheader,
        loginuser,
        openclose,
        productgroup,
        productadmin,
        transactions,
        inventory,
        library,
        vendor
    
    },
    mixins:[datamethods, format,style,inventoryservice],
    computed:{
        ...mapFields([
            'loggedIn',
            'currentNav',
            'username',
            'oldpassword',
            'loggedInUser.isAdmin',
            'logoOverride',
           'showHeader',
           'locationList',
           'locationList_Inventory',
           'reportImageBasePath'

        ]),
        mainDivClass(){
            if(this.isAdmin){return "mainDivAdmin"}
            else{return "mainDivFullWidth"}
        },
        
         inventoryUseInventoryLocationList(){
            if(window.INVENTORY_USE_INVENTORY_LOCATION_LIST==undefined){return false}
            else{return window.INVENTORY_USE_INVENTORY_LOCATION_LIST}
        },
    },
    methods:{
    
        logout(){
            this.$refs.transactions.resetfilter()
        },
        receiveMessage(event){
            try{
                var msg =  JSON.parse(event.data)
            }
            catch(err){
                return
            }
            
            var action = msg.action
            if(action !=undefined){
            
               // console.log("PA Receive Msg: " + action)
                switch (action) {
                    case 'refresh':
                        this.currentNav=''
                        if(window.SHOW_INVENTORY_LEVEL_ALERT){ this.getInventoryBelowTarget(-1)}
                        break;
                    case 'appupdate':
                        location.reload(true);
                    default:
                        break;
                }
                
            }
        },
        async GetLocations(){
            
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'locations')

            if(response.Successful){
                this.locationList=response.locationList
                if(this.inventoryUseInventoryLocationList){
                    //get a special one
                    this.GetLocations_Inventory()
                }else{
                    //use this list
                    this.locationList_Inventory=this.locationList
                }
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
         async GetLocations_Inventory(){
            
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'locations_inventory')

            if(response.Successful){
                this.locationList_Inventory=response.locationList
                
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
        async getreportImageBasePath(){
                console.log('img')
                //call api
                
                var response = await this.callAPI(null,'reportimagepath')
                //handle response
                if(response.Successful){
                    
                    this.reportImageBasePath = window.VUE_CONFIG_ReportAPI + response.StringResponse
                    console.log('img' + this.reportImageBasePath)
                }else{
                    this.message = response.Message
                }
                this.pleaseWait=false;
            }, 
    },
    mounted(){
        //to receive msgs
        window.addEventListener('message', this.receiveMessage)

        this.currentNav=''
        let urlParams = new URLSearchParams(window.location.search)
        let tmp = urlParams.get('email')
        if(tmp!=null){
            this.username = tmp;
        }

        let tmp2 = urlParams.get('temp')
        if(tmp2!=null){
            this.oldpassword = tmp2;
            this.$nextTick(()=>{
            //this.changepass()
            this.$refs.loginuser.changepassword();
            });
        }

    
        let tmp4 = urlParams.get('config')
        if(tmp4!=null){this.configOverride=tmp4 }

        

        console.log("inmount")
        window.onbeforeunload= function(event){
            event.preventDefault()
        }

        tmp = urlParams.get('header')
        if(tmp!=null){this.showHeader=tmp=='true'; }

        tmp = urlParams.get('token')
        if(tmp!=null){
            console.log('sso!')
            this.$refs.loginuser.post_login(tmp)
         }
         this.setColors();
         this.GetLocations();
         if(window.SHOW_INVENTORY_LEVEL_ALERT){
            this.getInventoryBelowTarget(-1)
         }
         

         var override =''
            if(override=='' && window.CONFIG_OVERRIDE!=undefined){
                override = window.CONFIG_OVERRIDE
            }

            this.AddConfigToAPI(override);
            
        this.getreportImageBasePath()
    }
}
</script>

<style lang="scss">
@import "@/assets/stylebase.scss";





body{
  height:95vh; 
  height: -webkit-fill-available;
  width:100vw;
  padding:0px;
  margin:0px;
  font-size:medium;
  color:var(--text-color);
}
.outerDiv{
  margin:0px;
  padding:0px;
    height:95vh;
    display:grid;
    grid-template-rows:auto auto;
    grid-template-areas: 
        "header header header"
        "center center center";
}
.mainDivFullWidth{

    grid-row:2;
    grid-column-start:1;
    grid-column-end: span 3;
    background-color:var(--background-color);
    padding:20px;
    height:96%;
}
.mainDivAdmin{
    grid-row:2;
    grid-column-start:1;
    grid-column-end: span 3;
    background-color:var(--background-color);
    padding:20px;
     height:96%;
}

.bordered{
    background-color: var(--frame-color);
    border-radius:5px;
    margin:10px 0px 10px 0px;
    padding:20px;
}
.responsemessage{
    font-size:large;
    color:red;
}

.horizFlex{
  display:flex;
  flex-direction: row;
  margin:0px;
}
.vertFlex{
  display:flex;
  flex-direction: column;
  margin:0px;
  
}
/* .horizFlexStretch{
  display:flex;
  padding:0px;
  flex-direction: row;
  margin:0px 0px 0px 10px ;
  justify-content:space-between;
} */
.rightjustified{
    text-align: right;
}
.leftjustified{
    text-align: left;
}
.subtitle{
    font-size:large;
    margin:20px;
}
.subtitleBold{
  font-size:large;
  margin:20px;
  font-weight: bold;
}
button:hover{
    background-color:var(--highlight-button-color);
    cursor:pointer;
}
button:disabled{
  background-color:gray;
}
.bold{
    font-weight: bold;
}
.left5{
    margin-left:5px;
}
.left10{
    margin-left:10px;
}
.right10{
    margin-right:10px;
}
.bottom10{
    margin-bottom:10px;
}
.messagetext{
    color:black;
    font-size:medium;

}
.pleasewaitlabel{
    color:orangered;
    font-size:large;
}
.titlelabel{
 
    font-size:x-large;
}
textarea{
    font:inherit;
}
.redtext{
  color:red;
  font-weight:bold;
}
.orangetext{
  color:orangered;
  font-weight:bold;
}
.headerclass{
     max-height:150px;
}
</style>